import { KIND_OF_REPORTS } from '@src/containers/App/TimeTracker/constants';
import { translateString } from '@src/util/intl/translateString';

const ATTENDANCE_COLUMNS = [
  {
    title: 'work.direction.attendance.table.date',
    dataIndex: 'date',
  },
  {
    title: 'work.direction.attendance.table.attendance',
    dataIndex: 'attendance',
  },
  {
    title: 'work.direction.attendance.table.absence',
    dataIndex: 'absence',
  },
  {
    title: 'work.direction.table.observations',
    dataIndex: 'observations',
  },
  { title: '', dataIndex: 'id' },
];

const WORKING_DAYS_COLUMNS = [
  { title: 'work.direction.attendance.table.date', dataIndex: 'date' },
  { title: 'work.direction.working.day.table.ordinary.working.day', dataIndex: 'workingDay' },
  { title: 'work.direction.working.day.table.marking', dataIndex: 'workingDayMarking' },
  { title: 'work.direction.working.day.table.queue', dataIndex: 'queue' },
  { title: 'work.direction.working.day.table.marking.queue', dataIndex: 'markingQueue' },
  { title: 'work.direction.working.day.table.missing.time', dataIndex: 'missingTime' },
  { title: 'work.direction.working.day.table.extra.time', dataIndex: 'extraTime' },
  { title: 'work.direction.working.day.table.other.markings', dataIndex: 'otherMarkings' },
  { title: 'work.direction.table.observations', dataIndex: 'observations' },
  { title: 'work.direction.table.dej', dataIndex: 'dej' },
  { title: '', dataIndex: 'id' },
];

const HOLIDAYS_COLUMNS = [
  { title: 'work.direction.holidays.tcdda', dataIndex: 'TCDDA' },
  { title: 'work.direction.common.table.date', dataIndex: 'date' },
  {
    title: 'work.direction.attendance.table.attendance',
    dataIndex: 'attendance',
  },
  { title: 'work.direction.attendance.table.absence', dataIndex: 'absence' },
  { title: 'work.direction.table.observations', dataIndex: 'observations' },
];

const MODIFICATIONS_COLUMNS = [
  {
    title: 'work.direction.modifications.table.assignDate',
    dataIndex: 'assignDate',
    width: '125px',
  },
  {
    title: 'work.direction.modifications.table.detail.shift',
    dataIndex: 'detailShift',
    width: '125px',
  },
  {
    title: 'work.direction.modifications.table.shiftExtension',
    dataIndex: 'shiftExtension',
    width: '125px',
  },
  {
    title: 'work.direction.modifications.table.shift.assigned.date',
    dataIndex: 'shiftAssignedDate',
    width: '125px',
  },
  {
    title: 'work.direction.modifications.table.start.shift',
    dataIndex: 'startShift',
    width: '125px',
  },
  {
    title: 'work.direction.modifications.table.new.schedule',
    dataIndex: 'newSchedule',
    width: '125px',
  },
  {
    title: 'work.direction.modifications.extension',
    dataIndex: 'extension',
    width: '125px',
  },
  {
    title: 'work.direction.modifications.request',
    dataIndex: 'request',
    width: '125px',
  },
  {
    title: 'work.direction.modifications.observations',
    dataIndex: 'observations',
    width: '200px',
  },
];

const ISSUES_COLUMNS = [
  {
    title: 'work.direction.issues.start.report',
    dataIndex: 'start',
  },
  {
    title: 'work.direction.issues.end.report',
    dataIndex: 'end',
  },
  {
    title: 'work.direction.issues.description',
    dataIndex: 'description',
  },
];

export const PDF_REPORTS_COLUMNS = {
  ATTENDANCE: ATTENDANCE_COLUMNS,
  WORKING_DAY: WORKING_DAYS_COLUMNS,
  HOLIDAYS: HOLIDAYS_COLUMNS,
  MODIFICATIONS: MODIFICATIONS_COLUMNS,
  ISSUES: ISSUES_COLUMNS,
};

export const PDF_FONT_FAMILY = 'Arial';
export const PDF_FONT_SIZE = {
  TITLE: 8,
  VALUE: 8,
};

/** Shared PDF palette (aligned with TablePDF and report exports). */
export const PDF_COLORS = {
  BORDER: '#888888',
  HEADER_BG: '#f0f0f0',
  TEXT: '#000000',
  TEXT_SECONDARY: '#666666',
  TEXT_MUTED: '#888888',
  LINK: '#1890ff',
};

export const LABEL_REPORTS = {
  NAME_EMPLOYEE: 'work.direction.table.fullname.employee',
  ID_EMPLOYEE: 'work.direction.table.id.card.employee',
  COMPANY: 'work.direction.table.company.employer',
  IDENTIFIER_EMPLOYER: 'work.direction.table.id.employer',
  PERIOD_CONSULTED: 'work.direction.table.period.consulted',
  PLACE: 'work.direction.table.place',
  JOB: 'work.direction.table.job',
  CIRCUNSTANCES: 'work.direction.table.circumstances',
};

export const ABSENCE_REASONS = [
  {
    short: 'A.I.',
    label: translateString('work.direction.glossary.item.AI'),
    code: 'unjustified_absence',
  },
  {
    short: 'A.J.',
    label: translateString('work.direction.glossary.item.AJ'),
    code: 'justified_absence',
  },
];

export const ABSENCE_TYPES = [
  { short: 'AT', label: translateString('work.direction.glossary.item.AT'), code: 'tardiness' },
  {
    short: 'C.T.',
    label: translateString('work.direction.glossary.item.CT'),
    code: 'shift_change',
  },
  {
    short: 'D.E.J.',
    label: translateString('work.direction.glossary.item.DEJ'),
    code: 'exceptional_schedule_distribution',
  },
  { short: 'H.E.', label: translateString('work.direction.glossary.item.HE'), code: 'overtime' },
  {
    short: 'J.O.',
    label: translateString('work.direction.glossary.item.JO'),
    code: 'regular_workday',
  },
  {
    short: 'L.M.',
    label: translateString('work.direction.glossary.item.LM'),
    code: 'medical_leave',
  },
  {
    short: 'P.G.R.',
    label: translateString('work.direction.glossary.item.PGR'),
    code: 'paid_leave',
  },
  { short: 'PREN.', label: translateString('work.direction.glossary.item.PREN'), code: 'prenatal' },
  {
    short: 'P.S.G.R.',
    label: translateString('work.direction.glossary.item.PSGR'),
    code: 'unpaid_leave',
  },
  {
    short: 'POSTN.',
    label: translateString('work.direction.glossary.item.POSTN'),
    code: 'postnatal',
  },
  {
    short: 'S.A.',
    label: translateString('work.direction.glossary.item.SA'),
    code: 'early_departure',
  },
  {
    short: 'D.F.',
    label: translateString('work.direction.glossary.item.DF'),
    code: 'holiday',
  },
  { short: 'VAC', label: translateString('work.direction.glossary.item.VAC'), code: 'vacation' },
  {
    short: 'H.E.',
    label: translateString('work.direction.glossary.item.HE'),
    code: 'extra_hours',
  },
  {
    short: 'P.H.E.',
    label: translateString('work.direction.glossary.item.PHE'),
    code: 'extra_hours_extraordinary',
  },
];
export const GLOSSARY_ITEMS = [
  ...ABSENCE_REASONS,
  ...ABSENCE_TYPES,
  { short: 'T.C.D.D.A.', label: translateString('work.direction.glossary.item.TCDDA'), code: null },
];

export const COLUMNS_TO_BE_COLORED_BY_REPORT = {
  [KIND_OF_REPORTS.ATTENDANCE]: ['attendance', 'absence', 'observations'],
  [KIND_OF_REPORTS.DAILY]: ['workingDayMarking', 'markingQueue', 'observations'],
  [KIND_OF_REPORTS.HOLIDAYS]: ['attendance', 'absence', 'observations'],
};

export const RULE_COLORS = {
  G: '#52c41a',
  Y: '#DFAB00',
  R: '#f5222d',
};

export const CREATION_STATES = {
  SYSTEM: 'SYSTEM',
  USER: 'USER',
  SYSTEM_MODIFIED: 'SYSTEM_MODIFIED',
};
